import styled from '@emotion/styled'

export const TextLabel = styled.p`
  padding-bottom: 40px;
`